module.exports = __webpack_public_path__ + "static/media/dashboardlogo.414c341f.jpg";